export type RewardType = {
  id: number
  name: string
  rarity: number
  kind: number
}

export const rewardRarityObj = {
  1: ['Common', 'Обычный'],
  2: ['Uncommon', 'Необычный'],
  3: ['Rare', 'Редкий'],
  4: ['Epic', 'Эпический'],
  5: ['Legendary', 'Легендарный'],
} as const

export enum RewardKindToCurrency {
  'gamed' = 1,
  'tgStar' = 2,
}

// это очень важный костыль, не убирать :D
export enum AmbassadorImgSrc {
  'rocket' = 1,
  'trappedheart' = 2,
  'cake' = 3,
  'lollipop' = 4,
  'teddybear' = 5,
  'lunarsnake' = 6,
  'trophy' = 8,
  'scaredcat' = 10,
}

export enum SingleDropRewardNameToText {
  'Building' = 30001,
  'Coin' = 20001,
  'Skin' = 10001,
}
